export const formatName = (
  firstName?: string,
  lastName?: string,
  placeholder = ''
): string => {
  if (!firstName && !lastName) {
    return placeholder;
  }
  let result = placeholder;
  if (firstName) {
    result = `${firstName} `;
  }
  if (lastName) {
    result = result + lastName;
  }
  return result.trim();
};
